var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
import systemHealthBannerActions from "./SystemHealthBannerActions.js";
import * as _ from "lodash";
import { BannerLevel } from "@ane/core/lib/services/BannerService";
const defaultState = {
  healthMessages: [],
  workspaceId: null,
  managementGroup: null
};
class SystemHealthBannerReducer {
  fetchSystemHealthMessage(state, actionResult) {
    let newState = __spreadProps(__spreadValues({}, state), {
      healthMessages: []
    });
    if (!actionResult.error) {
      let { managementGroup, workspaceId } = actionResult.payload;
      let mdsHealthMessages = actionResult.payload.healthMessage;
      _.forOwn(mdsHealthMessages, (messageBody, id) => {
        if (!!messageBody) {
          newState.healthMessages.push({
            id,
            message: `${messageBody.Message} ${messageBody.ETAMessage} ${messageBody.UpdatedTime}`,
            // @ts-ignore
            level: this.getBannerLevel(messageBody.Level)
          });
        }
      });
      newState.workspaceId = workspaceId;
      newState.managementGroup = managementGroup;
    } else {
      newState.healthMessages.push({
        id: "default-Failure",
        message: `ExP is experiencing a service outage. In an emergency for a flight causing significant live site harm and major business impact, see <a href="https://aka.ms/exp/EmergencyShutdownInfo" target="_blank">info</a> for shutdown options.`,
        level: this.getBannerLevel(BannerLevel.danger)
      });
    }
    return newState;
  }
  getBannerLevel(level) {
    if (!level) {
      return BannerLevel.danger;
    }
    return BannerLevel[level.toLowerCase()] || BannerLevel.warning;
  }
}
const SystemHealthBannerReducer$1 = createReducer(systemHealthBannerActions, new SystemHealthBannerReducer(), defaultState);
export {
  SystemHealthBannerReducer,
  SystemHealthBannerReducer$1 as default
};
//# sourceMappingURL=SystemHealthBannerReducer.js.map
